import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ToastContainer } from 'react-toastify';
// import React, { useEffect } from 'react';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import JoinUs from './pages/JoinUs';
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Login from './pages/Login';
import EmployeePortal from './pages/EmployeePortal';
import Footer from './components/Footer';
import ScrollToTop from './ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import SiteNavbar from './components/SiteNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  const isEmployee = location.pathname.startsWith('/employee');
  const isLogin = location.pathname === '/login';
  const showSiteShell = !isDashboard && !isEmployee && !isLogin;

  // useEffect(() => {
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };
// // Disable F12 and Ctrl+Shift+I
//     const handleKeyDown = (e) => {
//       if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
//         e.preventDefault();
//       }
//     };

//     document.addEventListener('contextmenu', handleContextMenu);
//     document.addEventListener('keydown', handleKeyDown);

//     return () => {
//       document.removeEventListener('contextmenu', handleContextMenu);
//       document.removeEventListener('keydown', handleKeyDown);
//     };
//   }, []);

  return (
    <div className="App">
      <ToastContainer />
      {showSiteShell && <SiteNavbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:filter" element={<Gallery />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/employee"
          element={
            <PrivateRoute requiredRole="employee">
              <EmployeePortal />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute requiredRole="admin">
              <ThemeProvider>
                <Dashboard />
              </ThemeProvider>
            </PrivateRoute>
          }
        />
      </Routes>
      {showSiteShell && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <DndProvider backend={HTML5Backend}>
          <ScrollToTop />
          <AppContent />
        </DndProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;